import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as r } from "react";
const s = ({
  title: o,
  titleId: l,
  ...c
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...c,
    children: [
      o ? /* @__PURE__ */ e.jsx("title", { id: l, children: o }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M625.316 961.215c-193.709 0-340.96-114.236-384.704-294.358H206.87c-34.33 0-62.264-27.935-62.264-62.264s27.935-62.264 62.264-62.264h21.518c0-18.182.162-38.333.455-56.699H206.87c-34.33 0-62.264-27.935-62.264-62.264s27.935-62.264 62.264-62.264h37.643c49.331-180.13 197.775-298.329 380.803-298.329 80.498 0 158.076 27.013 224.34 78.103 13.146 10.127 21.587 24.801 23.729 41.312 2.127 16.489-2.281 32.82-12.426 45.996-11.89 15.416-29.859 24.254-49.32 24.254-13.705 0-27.215-4.612-38.058-12.985-44.251-34.117-95.536-52.159-148.264-52.159-115.088 0-208.123 66.478-249.901 173.833h354.308c34.33 0 62.264 27.935 62.264 62.264s-27.935 62.243-62.264 62.243H353.311c-.265 17.738-.404 38.425-.415 56.699h350.356c34.33 0 62.264 27.935 62.264 62.264s-27.935 62.264-62.264 62.264H370.208c37.481 107.426 129.41 169.84 255.11 169.84 54.591 0 107.426-19.276 152.782-55.766 10.998-8.867 24.864-13.752 39.013-13.752 18.965 0 36.651 8.474 48.53 23.24 10.421 12.974 15.174 29.209 13.378 45.731-1.792 16.551-9.921 31.398-22.895 41.819-67.697 54.437-147.511 83.235-230.808 83.235z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = r(s);
export {
  m as default
};
